import { FigureVarData, isFigureVarData } from "./FigureVarData";

export interface FigureLegendData {
  id: string;
  legendLabel: string;
  properties: FigureVarData[];
}

/**
 * Type guard to check if an object is a FigureLegendData
 *
 * @param obj - The object to check
 * @returns - true if the object is a FigureLegendData
 */
export const isFigureLegendData = (obj: unknown): obj is FigureLegendData => {
  if (typeof obj !== "object" || obj === null) {
    return false;
  }
  const chkObj = obj as FigureLegendData;
  if (typeof chkObj.id !== "string") {
    return false;
  }
  if (typeof chkObj.legendLabel !== "string") {
    return false;
  }
  if (!Array.isArray(chkObj.properties)) {
    return false;
  }
  if (chkObj.properties.some((prop) => !isFigureVarData(prop))) {
    return false;
  }
  return true;
};
